import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { DIVISIONS_KEY } from '../../../../../../api/services/divisions';
import { getTargetGroups } from '../../../../../../api/services/mediaPlanning/targetGroup';
import usePlanStore from '../../../../../../store/planStore';
import prepareSelectData from '../utils/prepareSelectData';
import { Countries } from '../../../../../../shared/enums';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';

const useTargetGroups = (country: string) => {
  const {
    generalInfoState,
    selectedCountryISOCode,
    setSelectedCountryISOCode,
  } = usePlanStore();

  const { showError } = useError();

  const [isoCode, setIsoCode] = useState<string | null>(selectedCountryISOCode);

  useEffect(() => {
    if (country) {
      setSelectedCountryISOCode(country);
    }
  }, [country, setSelectedCountryISOCode]);

  useEffect(() => {
    setIsoCode(selectedCountryISOCode);
  }, [selectedCountryISOCode]);

  const {
    data: response,
    isFetching,
    isLoading,
    isError,
    refetch,
  } = useQuery(
    [
      'country-panel',
      DIVISIONS_KEY,
      country,
      isoCode,
      generalInfoState.division,
    ],
    () => getTargetGroups(generalInfoState.division, isoCode as Countries),
    {
      enabled: !!isoCode && !!generalInfoState.division,
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
    }
  );

  const targetGroups = response?.data?.targetGroup || [];
  return {
    data: prepareSelectData(targetGroups),
    isFetching,
    isLoading,
    isError,
    refetch,
  };
};

export default useTargetGroups;
